import { httpServices } from '../../../../apis'

import type { MembershipNotificationsSchema } from './types/membership.notifications.schema'

export type FetchMembershipNotificationsOptions = {
  queryParams?: {
    reset_cache: boolean
  }
}

export const fetchMembershipNotifications = async (
  options?: FetchMembershipNotificationsOptions
) => {
  const response = await httpServices.core.get<MembershipNotificationsSchema>(
    '/unread_notifications',
    {
      params: options?.queryParams || {}
    }
  )

  return response.data
}
